import { Box, Container, Typography } from "@mui/material";
import React from "react";
import data_center_1 from "../../Assets/data_center_1.png";
import data_center_2 from "../../Assets/data_center_2.png";
import data_center_3 from "../../Assets/data_center_3.png";
import data_center_4 from "../../Assets/data_center_4.png";
import data_center_5 from "../../Assets/data_center_5.png";
// import data_center_6 from "../../Assets/data_center_6.png";
// import data_center_7 from "../../Assets/data_center_7.png";
import data_center_8 from "../../Assets/data_center_8.png";
// import data_center_9 from "../../Assets/data_center_9.png";
import data_center_10 from "../../Assets/data_center_10.png";
import Textfield from "../Textfield";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testmonials.css";

const styles = {
  container: {
    textAlign: "center",
    py: { xs: 6, md: 8 },
  },
  titleText: {
    fontFamily: "Roboto",
    lineHeight: { xs: 1.4, md: 1.5 },
    fontWeight: "bold",
    fontSize: { xs: "1.3rem", md: "2rem" },
    color: "#6E6B7B",
    maxWidth: "800px",
    mx: "auto",
  },
  highlight: {
    fontWeight: "bold",
    color: "#1662A7",
  },
  logoImage: {
    maxWidth: "100%",
    height: "auto",
    filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
};

const SLIDER_SETTINGS = {
  dots: true,
  arrows: true,
  infinite: true,
  centerMode: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: "20px",
      },
    },
  ],
};

const CERTIFICATION_IMAGES = [
  { src: data_center_1, width: { xs: "80%", md: "90%" } },
  { src: data_center_2, width: { xs: "80%", md: "90%" } },
  { src: data_center_3, width: { xs: "80%", md: "70%" } },
  { src: data_center_4, width: { xs: "80%", md: "90%" } },
  { src: data_center_5, width: { xs: "60%", md: "70%" } },
  { src: data_center_8, width: { xs: "60%", md: "80%" } },
  { src: data_center_10, width: { xs: "60%", md: "90%" } },
];

function DataCenters() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#F8F8F8" }}>
      <Container maxWidth="lg" sx={styles.container}>
        {/* Compliance Statement */}
        <Box sx={{ mb: { xs: 6, md: 8 } }}>
          <Typography sx={styles.titleText}>
            RequireSign adheres to{" "}
            <span style={styles.highlight}>GLOBAL COMPLIANCE STANDARDS</span>{" "}
            for{" "}
            <span style={styles.highlight}>
              PRIVACY OF SENSITIVE INFORMATION
            </span>
          </Typography>
        </Box>

        {/* Certification Slider */}
        <Box
          sx={{
            mb: { xs: 6, md: 8 },
            "& .slick-slider": { mx: -2 },
            "& .slick-dots": {
              bottom: "-50px",
              "& li button:before": {
                color: "#1662A7",
                fontSize: "12px",
              },
              "& li.slick-active button:before": {
                color: "#1662A7",
              },
            },
            "& .slick-prev, & .slick-next": {
              zIndex: 1,
              "&:before": {
                color: "#1662A7",
                fontSize: "25px",
              },
            },
            "& .slick-prev": {
              left: "-30px",
            },
            "& .slick-next": {
              right: "-30px",
            },
          }}
        >
          <Slider {...SLIDER_SETTINGS}>
            {CERTIFICATION_IMAGES.map((image, index) => (
              <Box key={index} sx={{ px: 2, outline: "none" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "120px",
                    p: 2,
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={image.src}
                    alt={`Certification ${index + 1}`}
                    sx={{
                      ...styles.logoImage,
                      width: image.width,
                      maxHeight: "80px",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>

        {/* Email Signup */}
        <Box>
          <Textfield />
        </Box>
      </Container>
    </Box>
  );
}

export default DataCenters;
